<template>

    <div class="knowledge-nav">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="knowledge-nav__grid d-flex">
                        <a href="/donors" class="knowledge-nav__item knowledge-nav__item--donors d-flex"
                           :class="{'knowledge-nav__item--active': location.indexOf('/donors')>= 0}">
                            <div class="knowledge-nav__icon"></div>
                            <div class="knowledge-nav__title">Доноры</div>
                        </a>

                        <a href="/facilities/auto-help" class="knowledge-nav__item knowledge-nav__item--auto-help d-flex"
                           :class="{'knowledge-nav__item--active': location.indexOf('/facilities/auto-help') >= 0}">
                            <div class="knowledge-nav__icon"></div>
                            <div class="knowledge-nav__title">Автопомощь</div>
                        </a>

                        <a href="/facilities/pr-photo-help" class="knowledge-nav__item knowledge-nav__item--photo-help d-flex"
                           :class="{'knowledge-nav__item--active': location.indexOf('/facilities/pr-photo-help') >= 0}">
                            <div class="knowledge-nav__icon"></div>
                            <div class="knowledge-nav__title">PR и Фотопомощь</div>
                        </a>

                        <a href="/facilities/giveaway" class="knowledge-nav__item knowledge-nav__item--giveaway d-flex"
                           :class="{'knowledge-nav__item--active': location.indexOf('/facilities/giveaway') >= 0}">
                            <div class="knowledge-nav__icon"></div>
                            <div class="knowledge-nav__title">Отдам даром</div>
                        </a>

                        <a href="/homestays" class="knowledge-nav__item knowledge-nav__item--homestay d-flex"
                           :class="{'knowledge-nav__item--active': location.indexOf('/homestays') >= 0}">
                            <div class="knowledge-nav__icon"></div>
                            <div class="knowledge-nav__title">Передержка</div>
                        </a>

                    </div>

                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: "KnowledgeNav",
    data(){
        return{

        }
    },


    computed:{

      location(){

          return window.location.href

      }

    },

}
</script>

<style lang="scss" scoped>

    @import '../../../sass/components/knowledge-nav.scss'

</style>